export const MAX_BASE64_BYTES_PER_BATCH = 7 * 1024 * 1024;

const batchBase64ByteCount = batch =>
  batch.reduce((total, file) => total + file.base64Content.length, 0);

const fitsInCurrentBatch = (currentBatch, uploadFile, maxBytesPerBatch) =>
  currentBatch.length === 0 ||
  batchBase64ByteCount(currentBatch) + uploadFile.base64Content.length <=
    maxBytesPerBatch;

export const groupFilesByBatchSize = (
  uploadFiles,
  maxBytesPerBatch = MAX_BASE64_BYTES_PER_BATCH
) =>
  uploadFiles.reduce(
    (batches, uploadFile) => {
      const currentBatch = batches[batches.length - 1];

      return fitsInCurrentBatch(currentBatch, uploadFile, maxBytesPerBatch)
        ? [...batches.slice(0, -1), [...currentBatch, uploadFile]]
        : [...batches, [uploadFile]];
    },
    [[]]
  );

export const uploadFileBatchesInParallel = async (
  fileBatches,
  addAttachment,
  correlatedObjectUri
) => {
  const batchResults = await Promise.all(
    fileBatches.map(batch =>
      addAttachment({ correlatedObjectUri, files: batch })
    )
  );

  const failedBatch = batchResults.find(([error]) => error);

  return failedBatch ? failedBatch[0] : null;
};
